/// <reference path="InvoiceLineReconciliationDataSource.ts" />

// The purchase invoices of the reconciliation list, from their lines.
class PurchaseInvoiceLineReconciliationDataSource extends InvoiceLineReconciliationDataSource
{
    protected lineEntityName() : string {
        return "PurchaseInvoiceLine";
    }

    protected prefetchKeyPaths() : string[] {
        return [
            "document.legalEntity.purchaseLedgerAccount",
            "document.legalEntity.expenditureLedgerAccount",
            "document.expenditureLedgerAccount",
            "document.ledgerAccount",
            "document.journalEntry",
            "ledgerAccount",
            "journalEntry",
            "expenditureLedgerAccount",
            "lineClassification.ledgerAccount",
            "product.purchaseLedgerAccount",
            "conceptItem.purchaseLedgerAccount"
        ];
    }
}
